<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Penalidade
            </span>
        </b-button>
        <penalidade-form
            tipoOperacao="i"
            :showModal="showModal"
            @modalFechado="showModal = false"
            @obterPenalidadesAtualizadas="$emit('obterPenalidadesAtualizadas')"
            :contrato="contrato"
        ></penalidade-form>
    </div>
</template>

<script>
import PenalidadeForm from './PenalidadeForm'

export default {
	components: {
		PenalidadeForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
